var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "input-group" }, [
    _c(
      "div",
      {
        staticClass: "timepicker input-controls-container clearfix",
        attrs: { role: "presentation" },
      },
      [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.timeInput,
              expression: "timeInput",
            },
            {
              name: "mask",
              rawName: "v-mask",
              value: "##:##",
              expression: "'##:##'",
            },
          ],
          ref: "input",
          staticClass: "form-control timepicker__input ui-timepicker-input",
          attrs: {
            type: "text",
            id: _vm.id,
            placeholder: _vm.placeholder,
            "aria-describedby": _vm.id + "_description",
          },
          domProps: { value: _vm.timeInput },
          on: {
            keydown: _vm.inputKeyDown,
            input: function ($event) {
              if ($event.target.composing) return
              _vm.timeInput = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sr-only", attrs: { id: _vm.id + "_description" } },
          [
            _vm._v(
              "\r\n        strzalka w lewo wybór godzin,\r\n        strzalka w prawo wybór minut,\r\n        strzałki góra dół zmiana wartości\r\n      "
            ),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sr-only", attrs: { "aria-live": "assertive" } },
          [
            _vm.show
              ? _c("span", [
                  _vm.selecting == "hours"
                    ? _c("span", [_vm._v("Wybór godziny")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.selecting == "minutes"
                    ? _c("span", [_vm._v("Wybór minut")])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "input-controls jsInputTimepickerControls",
            attrs: { role: "presentation" },
          },
          [
            _c("span", {
              staticClass: "prev icon-angle-top",
              attrs: {
                title: "Kliknięcie powoduje dodanie do godziny 30 minut",
              },
              on: {
                click: function ($event) {
                  return _vm.addTime(30)
                },
              },
            }),
            _vm._v(" "),
            _c("span", {
              staticClass: "next icon-angle-bottom",
              attrs: {
                title: "Kliknięcie powoduję odjęcie od godziny 30 minut",
              },
              on: {
                click: function ($event) {
                  return _vm.addTime(-30)
                },
              },
            }),
          ]
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.show,
            expression: "show",
          },
        ],
        ref: "list",
        staticClass: "timepicker__list",
        attrs: { "aria-hidden": !_vm.show },
      },
      [
        _c(
          "ul",
          {
            ref: "listHours",
            staticClass: "timepicker__list-hours",
            class: { active: _vm.selecting == "hours" },
            on: {
              mouseenter: function ($event) {
                _vm.selecting = "hours"
              },
            },
          },
          _vm._l(_vm.hourList, function (item, idx) {
            return _c(
              "li",
              {
                key: idx,
                staticClass: "timepicker__list-item",
                class: { active: item == _vm.hours },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.hours = item
                        _vm.setFocus()
                      },
                    },
                  },
                  [_vm._v(_vm._s(item))]
                ),
              ]
            )
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "ul",
          {
            ref: "listMinutes",
            staticClass: "timepicker__list-minutes",
            class: { active: _vm.selecting == "minutes" },
            on: {
              mouseenter: function ($event) {
                _vm.selecting = "minutes"
              },
            },
          },
          _vm._l(_vm.minuteList, function (item, idx) {
            return _c(
              "li",
              {
                key: idx,
                staticClass: "timepicker__list-item",
                class: { active: item == _vm.minutes },
              },
              [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        _vm.minutes = item
                        _vm.setFocus()
                      },
                    },
                  },
                  [_vm._v(_vm._s(item))]
                ),
              ]
            )
          }),
          0
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }